import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import UserRoles from 'app/types/UserRoles';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectSelectedPageIds } from 'app/store/pagesToolbar/pagesToolbar.selectors';
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Tooltip } from '@mui/material';
// Dialogs
import ExportWorkspacePagesToPDFDialog from '@root/dialogs/ExportWorkspacePagesToPDF.dialog';
// Components
import Icon from 'app/components/Icon';
import { IconButton } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
import usePagesUtilities from '../utils/usePagesUtilities';
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

const ExportPagesToPDFButton = () => {
  const { t } = useTranslation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const trialMode = useAppSelector(selectTrialMode);
  const myUser:any = useAppSelector(selectMyUser);
  const selectedPageIds = useAppSelector(selectSelectedPageIds);

  const { getPagesByIds } = usePagesUtilities();

  const { open, toggle } = useToggle();

  const pages = useMemo(() => {
    return getPagesByIds(selectedPageIds);
  }, [selectedPageIds, getPagesByIds]);

  const handleCallback = () => {
    dispatch(MixpanelActions.handleCasePagesBulkActionClick({ action: 'export', numberOfPages: pages.length }));
  }

  const isUserRoleAdminOrStaff = myUser?.role === UserRoles.Admin || myUser?.role === UserRoles.Staff;
  const hasPages = pages && pages.length > 0;

  if (
    trialMode ||
    !isUserRoleAdminOrStaff ||
    !hasPages
  ) return null;
  return (
    <Fragment>
      <Tooltip title={t('pages.workspace.exportPdfButton')}>
        <IconButton
          name="Export pages to pdf"
          onClick={toggle}
        ><Icon icon="save_alt" /> </IconButton>
      </Tooltip>
      {open ? (
        <ExportWorkspacePagesToPDFDialog
          open={open}
          onClose={toggle}
          onCallback={handleCallback}
          pages={pages}
        />
      ) : null}
    </Fragment>
  )
}

export default ExportPagesToPDFButton;
